// extracted by mini-css-extract-plugin
export default {"wrapper":"Benefit_wrapper__PXMHI"};